import HeaderPortal from "components/portal/header-portal";
import DeleteTimesheetEntry from "./components/delete";
import LockAlert from "@/modules/timesheet/logs/log/view/components/lock-alert";
import ReviewSuccess from "@/modules/timesheet/logs/log/view/components/review-success";
import { TimesheetViewSkeleton } from "@/modules/timesheet/logs/log/view/loader";
import { ViewField } from "@/components/field";
import { fetchTimesheetEntry } from "@/modules/timesheet/api";
import { formatDateForDisplay } from "@/lib/utils";
import { useFetch } from "@/hooks/useFetch";
import { useLockTimesheet } from "components/timesheet/lock/useLock";
import { useParams } from "react-router-dom";

export default function TimesheetView() {
  const { day, timesheetId } = useParams();

  const { data, isLoading, isError } = useFetch({
    queryKey: ["timesheet", timesheetId],
    queryFn: () => fetchTimesheetEntry({ timesheetId }),
  });
  const { canEdit } = useLockTimesheet({ date: day });

  if (isLoading) {
    return <TimesheetViewSkeleton />;
  }

  if (isError) {
    return "error";
  }

  const isReviewed =
    data.logged_hours &&
    data.logged_hours === data.approved_hours + data.unapproved_hours;

  return (
    <>
      <div className="p-6 grid md:grid-cols-10 grid-cols-1  md:h-full gap-4 md:gap-6 flex-1">
        <div className="md:col-span-4 flex flex-col gap-4 md:border-r md:border-solid ">
          <LockAlert date={day} canEdit={canEdit} isReviewed={isReviewed} />
          <ReviewSuccess canEdit={canEdit} isReviewed={isReviewed} />
          <ViewField label="Date" value={formatDateForDisplay(data.date)} />
          <ViewField label="Project" value={data.project.name} />
          <ViewField label="Job" value={data.job.name} />

          <ViewField label="Milestone" value={data.milestone?.name} />
          <ViewField label="Tag" value={data.tag?.label} />

          <ViewField label="Hours" value={data.logged_hours} />
          <ViewField
            label="Approved"
            value={
              (data.approved_hours || data.unapproved_hours) &&
              data.approved_hours
            }
          />
          <ViewField
            label="Unapproved"
            value={
              (data.approved_hours || data.unapproved_hours) &&
              data.unapproved_hours
            }
          />
            <ViewField
              label="Reason"
              value={data.reason}
              className={"whitespace-pre-wrap"}
            />
        </div>
        <div className="md:col-span-6">
          <ViewField
            label="Description"
            value={data?.description}
            className={"whitespace-pre-wrap "}
          />
        </div>
      </div>
      {canEdit && !data.approved_hours && !data.unapproved_hours && (
        <HeaderPortal>
          <DeleteTimesheetEntry entryId={data.id} date={data.date} />
        </HeaderPortal>
      )}
    </>
  );
}
